import { appName } from '../../../../config/uri';

const tr = {
  constants: {
    packages: {
      users: 'Localização',
      emergency: 'Botão de Pânico',
      driving: 'Direção Inteligente',
      doctor: `${appName} Médico`,
      doctor_all: 'Médico especialista',
      pack: 'Pacote',
    },
    maritalStatus: {
      single: 'Solteiro(a)',
      engaged: 'Noivo(a)',
      married: 'Casado(a)',
      divorced: 'Dirvociado(a)',
      separated: 'Separado(a)',
      widowed: 'Viúvo(a)',
      other: 'Outro',
    },
    pinStatus: {
      availabled: 'Disponível',
      enabled_ecommerce: 'Habilitado pelo Ecommerce',
      enabled_phisycal: 'Habilitado pela loja física',
      canceled: 'Cancelado pelo Ecommerce',
      enabled_by_user: 'Habilitado pelo usuário',
      enabled_by_admin: 'Habilitado pelo administrador',
      disabled_by_api: 'Desabilitado automaticamente',
      created: 'Criado',
    },
    genres: {
      male: 'Masculino',
      female: 'Feminino',
      not_specified: 'Não especificado',
    },
    epayTransactionStatus: {
      successfully: 'Efetuada com sucesso',
      successfully_ecommerce: 'Efetuada com sucesso - Ecommerce',
      successfully_phisycal: 'Efetuada com sucesso - Cartão Físico',
      canceled: 'Cancelado',
      successfully_canceled: 'Cancelada com sucesso',
      failed: 'Falhou',
    },
    yes: 'Sim',
    no: 'Não',
    appointmentRating: {
      all: 'Todas',
      doctor: 'Médico',
      attendant: 'Atendente',
    }
  },
};

export default tr;
